<template>
    <div v-if="hasCompleteTheLook" class="product_look_builder">
        <template v-if="!isLoading">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="pb-6">Complete The Look</h3>
                    </div>
                </div>
            </div>
            <div class="container" :class="{ 'px-0' :windowWidth <= 992 }">
                <div v-if="windowWidth <= 768" class="row mx-0">
                    <div class="col-12">
                        <slick ref="lookMobileSlider" :options="slickOptions" class="product__carousel">
                            <listing-product-item 
                                v-for="product in completeLookProducts" 
                                :key="product.id" 
                                :product="product"
                                :hideVariantSelector="false"
                                :lookEnabled="true"
                                :translations="translations"
                            />
                        </slick>
                    </div>
                </div>

                <div v-else class="row">
                    <div class="col-12">
                    <slick :options="slickOptions" class="product__carousel">
                    <listing-product-item 
                        v-for="product in completeLookProducts" 
                        :key="product.id" 
                        :product="product"
                        :translations="translations"
                        :hideVariantSelector="false"
                        :lookEnabled="true"
                        :class="`px-1`"
                    />
                    </slick>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="container">
            <div v-if="isLoading" class="text-center">
              <p class="lead" :data-products="completeLookProducts">Loading complete the look</p>
              <div class="loading-animation">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Slick from 'vue-slick';

import { storefrontRequestConfig } from '../utils/api'
import { transformProduct, multipleProductQuery }from '../utils/data'

import ListingProductItem from './listing-product-item.vue';


export default {
    name: 'ProductCompleteLook',

    props: {
        completeLookProductIds: {
            type: String,
            default: ''
        },

        currencyIso: {
            type: String,
            default: 'USD'
        },

        translations: {
            type: Object
        }
    },

    components: {
        Slick,
        ListingProductItem
    },

    data: () => ({
        isLoading: true,
        completeLookProducts: [],
        hasCompleteTheLook: false,
        windowWidth: window.innerWidth,
        slickOptions: {
            slidesToShow: 4,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            variableWidth: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }]
        }
    }),

    watch: {
        windowWidth(val) {
            if(val <= 991) {
                setTimeout(() => {
                    this.$refs.lookMobileSlider.reSlick()
                }, 500)
            }
        }
    },

    computed: {
        completeLookIds() {
            return this.completeLookProductIds !== '' ? JSON.parse(this.completeLookProductIds) : []
        }
    },

    created() {
        window.addEventListener('resize', this.handleResize)
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },

    mounted() {
        if(this.completeLookIds.length >= 1) {
            this.hasCompleteTheLook = true
            this.populateCompleteLookList()
        } else {
            this.hasCompleteTheLook = false
        }
    },

    methods: {
        handleResize() {
            clearTimeout(this.resizeId)
            this.resizeId = setTimeout(() => {
                this.windowWidth = window.innerWidth      
            }, 500)
        },

        async populateCompleteLookList() {
            this.isLoading = true;
            const ids = this.completeLookIds.map((id) => `"${btoa(`gid://shopify/Product/${id}`)}"`);

            const { data, status, statusText } = await axios.post(`https://${Shopify.shop}//api/graphql`, multipleProductQuery({currency: this.currencyIso, ids}), storefrontRequestConfig)

            if(status === 200) {
                this.completeLookProducts = data.data.nodes.map(node => transformProduct(node)).filter(Boolean)
                this.isLoading = false

            } else {
                this.isLoading = false
                alert(`Can't reach the server at this time. Please try again later`)
                console.log(statusText);
            }
        }
    }
}
</script>